// Servicio de empresa / sucursales / feriados (A3).
import { http } from '@/services/http';

/** GET /company_config — configuración de la empresa (primer registro). */
export function getCompanyConfig() {
  return http.get('/company_config');
}

/** PUT /company_config — guardar configuración (puede requerir rutas del backend). */
export function saveCompanyConfig(payload) {
  return http.put('/company_config', payload);
}

/** GET /branches?company=... — lista de sucursales. */
export function listBranches(params) {
  return http.get('/branches', { params });
}

/** POST /branches — crear sucursal. */
export function createBranch(payload) {
  return http.post('/branches', payload);
}

/** PUT /branches — actualizar sucursal (según contrato del backend). */
export function updateBranch(payload) {
  return http.put('/branches', payload);
}

/** GET /holidays — lista de feriados. */
export function listHolidays(params) {
  return http.get('/holidays', { params });
}

/** POST /holidays — crear feriado. */
export function createHoliday(payload) {
  return http.post('/holidays', payload);
}